// --
import { getTableScrollbarWidth } from './tableScrollbarWidth';

/**
 * Hook přidá k hlaviččce tabulky posunutí (kvůli scrollbaru) aby byly správně sloupečky hlavičky zarovnané se sloupečky těla - u toho je nutné nastavit scroll vždy!
 * POZOR - nutné nastavit scroll vždy na tabulce (nebo divu nad tím), která je scrolovací "tělo" - např. <VerticalLayout.Center scrollable alwaysScroll>.
 */
export function useFixedHeader(hooks: any) {
  hooks.getHeaderGroupProps.push(getRowStyles);
}

useFixedHeader.pluginName = 'useFixedHeader';

const getRowStyles = (props: any) => {
  const scrollbarWidth = getTableScrollbarWidth();

  return [
    props,
    {
      style: {
        paddingRight: `${scrollbarWidth}px`,
      },
    },
  ];
};
